import TrainingDials from './TrainingDials';

export default TrainingDials;
